module.exports = __webpack_public_path__ + "static/media/utilisation.a8b6caee.jpg";